import { ApiCore } from '@/services/api/utils/core.js'
import axios from 'axios'
import { handleError, handleResponse } from './utils/response'
const url = 'v1/visualization/guest-token'

const supersetDashboardApi = new ApiCore({
	index: true,
	findOne: true,
	url: url,
})

supersetDashboardApi.getEmbedId = async (tabId) =>{
	return axios.get(`/api/v1/visualization/embed/${tabId}`)
	.then(handleResponse)
	.catch(handleError)
}

export default supersetDashboardApi
